export class FeatureState {
    constructor(init) {
        Object.assign(this, init);
    }
}
//# sourceMappingURL=feature-state.js.map